import { render, staticRenderFns } from "./areaLibrary.vue?vue&type=template&id=52ced88c&scoped=true"
import script from "./areaLibrary.vue?vue&type=script&lang=js"
export * from "./areaLibrary.vue?vue&type=script&lang=js"
import style0 from "./areaLibrary.vue?vue&type=style&index=0&id=52ced88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ced88c",
  null
  
)

export default component.exports